import { baseAssets, darkModeBaseAssets, getToolkitCoverAssetId, getToolkitHeroAssetId, ThemeAssets } from './assets'
import { CENTER_OF_EXCELLENCE } from '../../../centerOfExcellence/types'
import { WELLNESS_TOOLKIT_PROMOTION } from '../../../wellnessToolkit/types'
import {
  AURORA_CARE_NAV_CDN_ASSETS_LINK_BASE,
  AURORA_CDN_ASSETS_LINK_BASE,
  AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE,
  CDN_ASSETS_LINK_BASE,
  MICROSITE_AURORA_CDN_ASSETS_LINK_BASE,
  REGISTRATION_GRID_AURORA_CDN_ASSETS_LINK_BASE,
  RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE,
} from '../constants'

const AURORA_CARE_OPTIONS_HERO_PATH = `${AURORA_CDN_ASSETS_LINK_BASE}/careOptions/hero`
const AURORA_CARE_OPTIONS_COMPACT_PATH = `${AURORA_CDN_ASSETS_LINK_BASE}/careOptions/compact`
const TOOLKIT_PATH = `${AURORA_CDN_ASSETS_LINK_BASE}/toolkits`
const TOOLKIT_COVERS_PATH = `${AURORA_CDN_ASSETS_LINK_BASE}/toolkits/covers-v2`
const TOOLKIT_HEADER_PATH = `${AURORA_CDN_ASSETS_LINK_BASE}/toolkits/header`

export const auroraAssets: ThemeAssets = {
  ...baseAssets,
  mobileSliderThumb: {
    assetNames: {
      defaultAsset: 'auroraSliderThumb',
    },
  },
  auroraCareOptionSelfTriageHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/selfTriage-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/selfTriage.png`,
    },
  },
  auroraCareOptionChildTriageHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/childTriage-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/childTriage.png`,
    },
  },
  auroraCareOptionChildTriageCompact: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/child-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/child.png`,
    },
  },
  auroraCareOptionMentalHealthCoachingHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/coaching-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/coaching.png`,
    },
  },
  auroraCareOptionMentalHealthCoachingCompact: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/coaching-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/coaching.png`,
    },
  },
  auroraCareOptionParentingCoachingHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/parentCoaching-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/parentCoaching.png`,
    },
  },
  auroraCareOptionParentingCoachingCompact: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/parentsCoaching-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/parentsCoaching.png`,
    },
  },
  auroraCareOptionCouplesTherapyHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/couplesTherapy-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/couplesTherapy.png`,
    },
  },
  auroraCareOptionCouplesTherapyCompact: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/couplesTherapy-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/couplesTherapy.png`,
    },
  },
  auroraCareOptionFamilyTherapyHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/familyTherapy-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/familyTherapy.png`,
    },
  },
  auroraCareOptionFamilyTherapyCompact: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/familyTherapy-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/familyTherapy.png`,
    },
  },
  auroraCareOptionControlledMedsHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/controlledMeds-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/controlledMeds.png`,
    },
  },
  auroraCareOptionMedicationConsultationHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/medsConsult-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/medsConsult.png`,
    },
  },
  auroraCareOptionMedicationConsultationCompact: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/medsConsult-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_COMPACT_PATH}/medsConsult.png`,
    },
  },
  auroraCareOptionMedicationConsultationChildrenTeensHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/medsConsultTeens-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/medsConsultTeens.png`,
    },
  },
  auroraCareOptionAlcoholUseDisorderHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/alcoholSubstanceUse-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/alcoholSubstanceUse.png`,
    },
  },
  auroraCareOptionComplexCareHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/complexCare-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/complexCare.png`,
    },
  },
  auroraCareOptionDBTHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/selfHarmSupport-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/selfHarmSupport.png`,
    },
  },
  auroraCareOptionIOPHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/iop-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/iop.png`,
    },
  },
  auroraCareOptionPHPHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/php-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/php.png`,
    },
  },
  auroraCareOptionResidentialTreatmentHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/residentialTreatment-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/residentialTreatment.png`,
    },
  },
  auroraCareOptionInpatientHospitalizationHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/inpatient-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/inpatient.png`,
    },
  },
  auroraCareOptionOnsiteTherapyHero: {
    assetNames: {
      isMobileSized: `${AURORA_CARE_OPTIONS_HERO_PATH}/onsite-mobile.png`,
      defaultAsset: `${AURORA_CARE_OPTIONS_HERO_PATH}/onsite.png`,
    },
  },
  auroraFamilyCareOptionChild: {
    assetNames: {
      isMobileSized: `${AURORA_CDN_ASSETS_LINK_BASE}/careOptions/familyCareOptions/childMobile.png`,
      defaultAsset: `${AURORA_CDN_ASSETS_LINK_BASE}/careOptions/familyCareOptions/child.png`,
    },
  },
  [getToolkitCoverAssetId(WELLNESS_TOOLKIT_PROMOTION.FAMILY)]: {
    assetNames: {
      isMinWidthMobileS: `${TOOLKIT_COVERS_PATH}/Family.png`,
      defaultAsset: `${TOOLKIT_COVERS_PATH}/FamilySmall.png`,
    },
  },
  [getToolkitCoverAssetId(CENTER_OF_EXCELLENCE.HEALTH_CHALLENGES)]: {
    assetNames: {
      isMinWidthMobileS: `${TOOLKIT_COVERS_PATH}/HealthChallenges.png`,
      defaultAsset: `${TOOLKIT_COVERS_PATH}/HealthChallengesSmall.png`,
    },
  },
  [getToolkitCoverAssetId(CENTER_OF_EXCELLENCE.MANAGER_HUB)]: {
    assetNames: {
      isMinWidthMobileS: `${TOOLKIT_COVERS_PATH}/ManagingTeams.png`,
      defaultAsset: `${TOOLKIT_COVERS_PATH}/ManagingTeamsSmall.png`,
    },
  },
  [getToolkitCoverAssetId(CENTER_OF_EXCELLENCE.NEURODIVERSITY)]: {
    assetNames: {
      isMinWidthMobileS: `${TOOLKIT_COVERS_PATH}/Neurodiversity.png`,
      defaultAsset: `${TOOLKIT_COVERS_PATH}/NeurodiversitySmall.png`,
    },
  },
  [getToolkitCoverAssetId(WELLNESS_TOOLKIT_PROMOTION.PARENT)]: {
    assetNames: {
      isMinWidthMobileS: `${TOOLKIT_COVERS_PATH}/Parent.png`,
      defaultAsset: `${TOOLKIT_COVERS_PATH}/ParentSmall.png`,
    },
  },
  [getToolkitCoverAssetId(WELLNESS_TOOLKIT_PROMOTION.PURPOSE)]: {
    assetNames: {
      isMinWidthMobileS: `${TOOLKIT_COVERS_PATH}/Values.png`,
      defaultAsset: `${TOOLKIT_COVERS_PATH}/ValuesSmall.png`,
    },
  },
  [getToolkitCoverAssetId(WELLNESS_TOOLKIT_PROMOTION.RELATIONSHIPS)]: {
    assetNames: {
      isMinWidthMobileS: `${TOOLKIT_COVERS_PATH}/Relationships.png`,
      defaultAsset: `${TOOLKIT_COVERS_PATH}/RelationshipsSmall.png`,
    },
  },
  [getToolkitCoverAssetId(WELLNESS_TOOLKIT_PROMOTION.TRAUMA)]: {
    assetNames: {
      isMinWidthMobileS: `${TOOLKIT_COVERS_PATH}/Trauma.png`,
      defaultAsset: `${TOOLKIT_COVERS_PATH}/TraumaSmall.png`,
    },
  },
  [getToolkitCoverAssetId(WELLNESS_TOOLKIT_PROMOTION.WORK)]: {
    assetNames: {
      isMinWidthMobileS: `${TOOLKIT_COVERS_PATH}/Work.png`,
      defaultAsset: `${TOOLKIT_COVERS_PATH}/WorkSmall.png`,
    },
  },
  [getToolkitCoverAssetId(CENTER_OF_EXCELLENCE.WOMENS_HEALTH)]: {
    assetNames: {
      isMinWidthMobileS: `${TOOLKIT_COVERS_PATH}/WomensHealth.png`,
      defaultAsset: `${TOOLKIT_COVERS_PATH}/WomensHealthSmall.png`,
    },
  },
  [getToolkitHeroAssetId(WELLNESS_TOOLKIT_PROMOTION.FAMILY)]: {
    assetNames: {
      defaultAsset: `${TOOLKIT_HEADER_PATH}/Family.png`,
    },
  },
  [getToolkitHeroAssetId(WELLNESS_TOOLKIT_PROMOTION.PARENT)]: {
    assetNames: {
      defaultAsset: `${TOOLKIT_HEADER_PATH}/Parent.png`,
    },
  },
  [getToolkitHeroAssetId(WELLNESS_TOOLKIT_PROMOTION.PURPOSE)]: {
    assetNames: {
      defaultAsset: `${TOOLKIT_HEADER_PATH}/Values.png`,
    },
  },
  [getToolkitHeroAssetId(WELLNESS_TOOLKIT_PROMOTION.RELATIONSHIPS)]: {
    assetNames: {
      defaultAsset: `${TOOLKIT_HEADER_PATH}/Relationships.png`,
    },
  },
  [getToolkitHeroAssetId(WELLNESS_TOOLKIT_PROMOTION.TRAUMA)]: {
    assetNames: {
      defaultAsset: `${TOOLKIT_HEADER_PATH}/Trauma.png`,
    },
  },
  [getToolkitHeroAssetId(WELLNESS_TOOLKIT_PROMOTION.WORK)]: {
    assetNames: {
      defaultAsset: `${TOOLKIT_HEADER_PATH}/Work.png`,
    },
  },
  [getToolkitHeroAssetId(CENTER_OF_EXCELLENCE.HEALTH_CHALLENGES)]: {
    assetNames: {
      defaultAsset: `${TOOLKIT_HEADER_PATH}/HealthChallengesMobile.png`,
      isMinWidthMobileS: `${TOOLKIT_HEADER_PATH}/HealthChallenges.png`,
    },
  },
  [getToolkitHeroAssetId(CENTER_OF_EXCELLENCE.WOMENS_HEALTH)]: {
    assetNames: {
      defaultAsset: `${TOOLKIT_HEADER_PATH}/WomensHealthMobile.png`,
      isMinWidthMobileS: `${TOOLKIT_HEADER_PATH}/WomensHealth.png`,
    },
  },
  careNavigatorHighRiskCard: {
    assetNames: {
      defaultAsset: `${AURORA_CDN_ASSETS_LINK_BASE}/highRiskCareNavigatorHeroImage.png`,
      isMobileSized: `${AURORA_CDN_ASSETS_LINK_BASE}/highRiskCareNavigatorHeroImage-mobile.png`,
    },
  },
  meetWithAnExpert: {
    assetNames: {
      defaultAsset: `${MICROSITE_AURORA_CDN_ASSETS_LINK_BASE}/AuroraMeetWithAnExpertImageLarge.png`,
      isMobileSized: `${MICROSITE_AURORA_CDN_ASSETS_LINK_BASE}/AuroraMeetWithAnExpert.png`,
    },
  },
  careNavigatorContactCard: {
    assetNames: {
      defaultAsset: `${AURORA_CDN_ASSETS_LINK_BASE}/CareNavHomebaseCardImage.png`,
      isMobileSized: `${AURORA_CDN_ASSETS_LINK_BASE}/CareNavHomebaseCardImageMobile.png`,
      isMinWidthMobileM: `${AURORA_CDN_ASSETS_LINK_BASE}/CareNavHomebaseCardImageMobile@2x.png`,
      isMinWidthLaptop: `${AURORA_CDN_ASSETS_LINK_BASE}/CareNavHomebaseCardImage.png`,
    },
  },
  forkedTriageMainCareOptionIllustration: {
    assetNames: {
      defaultAsset: `${AURORA_CDN_ASSETS_LINK_BASE}/ForkedTriageMainCareOptionIllustration.png`,
    },
  },
  signUpPanelBlueSky: {
    assetNames: {
      defaultAsset: `${REGISTRATION_GRID_AURORA_CDN_ASSETS_LINK_BASE}/signUpPanelBlueSkyMobile.png`,
      isMinWidthLaptop: `${REGISTRATION_GRID_AURORA_CDN_ASSETS_LINK_BASE}/signUpPanelBlueSky.png`,
    },
  },
  paperAirplane: {
    assetNames: {
      defaultAsset: `${REGISTRATION_GRID_AURORA_CDN_ASSETS_LINK_BASE}/paperAirplane.png`,
    },
  },
  resourceGridRelaxField: {
    assetNames: {
      defaultAsset: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/relax-fields-mobile.png`,
      isMinWidthLaptop: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/relax-fields-desktop.png`,
    },
  },
  resourceGridMixes: {
    assetNames: {
      defaultAsset: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/mixes-mobile.png`,
      isMinWidthLaptop: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/mixes-desktop.png`,
    },
  },
  resourceGridLibrary: {
    assetNames: {
      defaultAsset: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/library-mobile.png`,
      isMinWidthLaptop: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/library-desktop.png`,
    },
  },
  resourceGridFocusingMind: {
    assetNames: {
      defaultAsset: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/focusing-mind-mobile.png`,
      isMinWidthLaptop: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/focusing-the-mind-desktop.png`,
    },
  },
  resourceGridEvent: {
    assetNames: {
      defaultAsset: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/event-new-mobile.png`,
      isMinWidthLaptop: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/event-new-desktop.png`,
    },
  },
  resourceGridBreathe: {
    assetNames: {
      defaultAsset: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/breathe-out-the-stress-new-mobile.png`,
      isMinWidthLaptop: `${RESOURCE_GRID_AURORA_CDN_ASSETS_LINK_BASE}/breathe-out-the-stress-new-desktop.png`,
    },
  },
  disclaimerIllustration: {
    assetNames: {
      defaultAsset: `${AURORA_CDN_ASSETS_LINK_BASE}/DisclaimerProviders.png`,
    },
  },
  careNavigatorEntryPoint: {
    assetNames: {
      defaultAsset: `${AURORA_CARE_NAV_CDN_ASSETS_LINK_BASE}/GeneralEntryPoint.png`,
      isMinWidthLaptop: `${AURORA_CARE_NAV_CDN_ASSETS_LINK_BASE}/GeneralEntryPointDesktop.png`,
    },
  },
  onboardingHi: {
    assetNames: {
      defaultAsset: `${AURORA_CDN_ASSETS_LINK_BASE}/Onboarding-Hi.png`,
    },
  },
  onboardingBiometricsFace: {
    assetNames: {
      defaultAsset: `${AURORA_CDN_ASSETS_LINK_BASE}/Onboarding-Biometrics-Face.png`,
    },
  },
  onboardingBiometricsFingerprint: {
    assetNames: {
      defaultAsset: `${AURORA_CDN_ASSETS_LINK_BASE}/Onboarding-Biometrics-Fingerprint.png`,
    },
  },
  onboardingNotifications: {
    assetNames: {
      defaultAsset: `${AURORA_CDN_ASSETS_LINK_BASE}/Onboarding-Notifications.png`,
    },
  },
  careInitialImage: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/care-initial-providers.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/care-initial-providers@3x.png`,
    },
  },
  neurodiversityToolkitAdultPlusChildHeader: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-tablet.png`,
      isMinWidthDesktopL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-desktopL.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-tablet.png`,
      isMinWidthMobileL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-mobile.png`,
      isMinWidthMobileM: `${CDN_ASSETS_LINK_BASE}/header-adult-light-mobileM.png`,
      isMinWidthMobileXs: `${CDN_ASSETS_LINK_BASE}/header-adult-light-mobileL.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-mobilexs.png`,
    },
  },
  neurodiversityToolkitAdultOnlyHeader: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-tablet.png`,
      isMinWidthDesktopL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-desktopL.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-tablet.png`,
      isMinWidthMobileL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-mobile.png`,
      isMinWidthMobileM: `${CDN_ASSETS_LINK_BASE}/header-adult-light-mobileM.png`,
      isMinWidthMobileXs: `${CDN_ASSETS_LINK_BASE}/header-adult-light-mobileL.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-mobilexs.png`,
    },
  },
  neurodiversityToolkitTeenHeader: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-light-tablet.png`,
      isMinWidthDesktopL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-light-desktopL.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-light-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-light-tablet.png`,
      isMinWidthMobileL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-light-mobile.png`,
      isMinWidthMobileM: `${CDN_ASSETS_LINK_BASE}/header-teen-light-mobileL.png`,
      isMinWidthMobileXs: `${CDN_ASSETS_LINK_BASE}/header-teen-light-mobileM.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/header-teen-light-mobilexs.png`,
    },
  },
  neurodiversitySupportSectionAdult: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult-tablet.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult-tablet.png`,
      isMobileSized: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult-mobile.png`,
    },
  },
  neurodiversitySupportSectionAdultPlusChild: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/care-options-combined-tablet.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/care-options-combined-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/care-options-combined-tablet.png`,
      isMobileSized: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/care-options-combined-mobile.png`,
    },
  },
  neurodiversitySupportSectionChild: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-tablet.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-tablet.png`,
      isMobileSized: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-mobile.png`,
    },
  },
  neurodiversitySupportSectionTeen: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-teen-tablet.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-teen-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-teen-tablet.png`,
      isMobileSized: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-teen-mobile.png`,
    },
  },
  neurodiversityGetInTouchSectionAdult: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/get-in-touch-tablet-mobile-adult.png`,
      isMinWidthDesktop: `${CDN_ASSETS_LINK_BASE}/get-in-touch-desktop-adult.png`,
    },
  },
  neurodiversityGetInTouchSectionTeen: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/get-in-touch-tablet-mobile-teen.png`,
      isMinWidthDesktop: `${CDN_ASSETS_LINK_BASE}/get-in-touch-desktop-teen.png`,
    },
  },
  neurodiversityResourceCoordinator: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/resource-coordinator.png`,
    },
  },
  neurodiversityContactCareNavigator: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/contact-cn-neuro-desktop.png`,
      isMobileSized: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/contact-cn-neuro-mobile.png`,
    },
  },
  traumaToolkitProviders: {
    assetNames: {
      defaultAsset: `${TOOLKIT_PATH}/trauma/TraumaProviders.png`,
    },
  },
  traumaToolkitSelfCare: {
    assetNames: {
      defaultAsset: `${TOOLKIT_PATH}/trauma/TraumaSelfCare.png`,
    },
  },
  traumaToolkitProvidersThumbnail: {
    assetNames: {
      defaultAsset: `${TOOLKIT_PATH}/trauma/TraumaProvidersThumbnail.png`,
    },
  },
  traumaToolkitSelfCareThumbnail: {
    assetNames: {
      defaultAsset: `${TOOLKIT_PATH}/trauma/TraumaSelfCareThumbnail.png`,
    },
  },
  toolkitHeroBackground: {
    assetNames: {
      defaultAsset: `${TOOLKIT_HEADER_PATH}/gradient-background-desktop.png`,
      isMinWidthLaptop: `${TOOLKIT_HEADER_PATH}/gradient-background-desktop.png`,
      isMinWidthTablet: `${TOOLKIT_HEADER_PATH}/gradient-background-tablet.png`,
      isMobileSized: `${TOOLKIT_HEADER_PATH}/gradient-background-mobile.png`,
    },
  },
  toolkitProvider: {
    assetNames: {
      defaultAsset: `${TOOLKIT_PATH}/Provider.png`,
    },
  },
}

export const auroraDarkModeAssets: ThemeAssets = {
  ...auroraAssets,
  ...darkModeBaseAssets,
  mobileSliderThumb: {
    assetNames: {
      defaultAsset: 'auroraSliderThumb',
    },
  },
  signUpPanelBlueSky: {
    assetNames: {
      defaultAsset: `${REGISTRATION_GRID_AURORA_CDN_ASSETS_LINK_BASE}/signUpPanelBlueSkyMobileDark.png`,
      isMinWidthLaptop: `${REGISTRATION_GRID_AURORA_CDN_ASSETS_LINK_BASE}/signUpPanelBlueSkyDark.png`,
    },
  },
  careNavigatorEntryPoint: {
    assetNames: {
      defaultAsset: `${AURORA_CARE_NAV_CDN_ASSETS_LINK_BASE}/GeneralEntryPoint.png`,
      isMinWidthLaptop: `${AURORA_CARE_NAV_CDN_ASSETS_LINK_BASE}/GeneralEntryPointDesktop.png`,
    },
  },
  neurodiversityToolkitAdultPlusChildHeader: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-tablet.png`,
      isMinWidthDesktopL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-desktopL.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-tablet.png`,
      isMinWidthMobileL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-mobile.png`,
      isMinWidthMobileM: `${CDN_ASSETS_LINK_BASE}/header-adult-dark-mobileL.png`,
      isMinWidthMobileXs: `${CDN_ASSETS_LINK_BASE}/header-adult-dark-mobileM.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-mobilexs.png`,
    },
  },
  neurodiversityToolkitAdultOnlyHeader: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-tablet.png`,
      isMinWidthDesktopL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-desktopL.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-tablet.png`,
      isMinWidthMobileL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-mobile.png`,
      isMinWidthMobileM: `${CDN_ASSETS_LINK_BASE}/header-adult-dark-mobileL.png`,
      isMinWidthMobileXs: `${CDN_ASSETS_LINK_BASE}/header-adult-dark-mobileM.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-mobilexs.png`,
    },
  },
  neurodiversityToolkitTeenHeader: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-dark-tablet.png`,
      isMinWidthDesktopL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-dark-desktopL.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-dark-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-dark-tablet.png`,
      isMinWidthMobileL: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-dark-mobile.png`,
      isMinWidthMobileM: `${CDN_ASSETS_LINK_BASE}/header-teen-dark-mobileL.png`,
      isMinWidthMobileXs: `${CDN_ASSETS_LINK_BASE}/header-teen-dark-mobileM.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/header-teen-dark-mobilexs.png`,
    },
  },
  neurodiversitySupportSectionAdult: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult-tablet.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult-tablet.png`,
      isMobileSized: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult-mobile.png`,
    },
  },
  neurodiversitySupportSectionAdultPlusChild: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/care-options-combined-tablet.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/care-options-combined-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/care-options-combined-tablet.png`,
      isMobileSized: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/care-options-combined-mobile.png`,
    },
  },
  neurodiversitySupportSectionChild: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-tablet.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-tablet.png`,
      isMobileSized: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-mobile.png`,
    },
  },
  neurodiversitySupportSectionTeen: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-teen-tablet.png`,
      isMinWidthDesktop: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-teen-desktop.png`,
      isMinWidthTablet: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-teen-tablet.png`,
      isMobileSized: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-teen-mobile.png`,
    },
  },
  neurodiversityGetInTouchSectionAdult: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/get-in-touch-tablet-mobile-adult.png`,
      isMinWidthDesktop: `${CDN_ASSETS_LINK_BASE}/get-in-touch-desktop-adult.png`,
    },
  },
  neurodiversityGetInTouchSectionTeen: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/get-in-touch-tablet-mobile-teen.png`,
      isMinWidthDesktop: `${CDN_ASSETS_LINK_BASE}/get-in-touch-desktop-teen.png`,
    },
  },
  neurodiversityResourceCoordinator: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/resource-coordinator.png`,
    },
  },
  neurodiversityContactCareNavigator: {
    assetNames: {
      defaultAsset: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/contact-cn-neuro-desktop.png`,
      isMobileSized: `${AURORA_NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/contact-cn-neuro-mobile.png`,
    },
  },
  toolkitHeroBackground: {
    assetNames: {
      defaultAsset: `${TOOLKIT_HEADER_PATH}/gradient-background-desktop-dark.png`,
      isMinWidthLaptop: `${TOOLKIT_HEADER_PATH}/gradient-background-desktop-dark.png`,
      isMinWidthTablet: `${TOOLKIT_HEADER_PATH}/gradient-background-tablet-dark.png`,
      isMobileSized: `${TOOLKIT_HEADER_PATH}/gradient-background-mobile-dark.png`,
    },
  },
}
